import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as n, createElementVNode as l } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconKeypad",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], m = /* @__PURE__ */ l("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.25 3.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM5 3.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm2.75 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm-5.5 2.75a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm2.75 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm2.75 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM2.25 9a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM5 9a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm2.75 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
  "clip-rule": "evenodd"
}, null, -1), _ = [
  m
];
function u(e, p, i, f, h, a) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--keypad"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Keypad",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, _, 10, c);
}
const v = /* @__PURE__ */ o(s, [["render", u]]);
export {
  v as default
};
//# sourceMappingURL=keypad.js.map
